// extracted by mini-css-extract-plugin
export default {"breadcrumb__root":"ZkbBgZzBKn1P7lrJQ_G5"};